import { SlotGame } from '@nolimitcity/slot-game/bin/SlotGame';
import { ArrayHelper } from '../../../core/utils/ArrayHelper';
import { GameConfig, SanGameMode } from '../../config/base/GameConfig';
import { IWinRatioConfig } from '../../config/base/IWinConfig';
import { IAllWinData, IBetWayWinData } from '../base/IData';
import { CoreData } from "./CoreData";
import { BasicSymbolType } from '../../../core/reel/symbol/config/IReelSymbolStruct';

export class WinGameData extends CoreData {

    private _winData: IBetWayWinData[] = [];
    private _allBetWayWinData: IAllWinData;

    public CreateNearWinMap(): boolean[][] {
        return this.createWaysNearWins(this.data.reels,[4,4,4,4,4]);// this.createNormalNearWinMap().map(a => a.map(v => v >= 0));
    }

    public get totalWinCombination(): number {
        return this.allBetWayWinData.totalWinCombination ?? 0;
    }

    public get brokeTheBank(): boolean {
        return this.data.brokeTheBank ?? false;
    }

    public get totalWin(): number {
        return this.data.accumulatedRoundWin ?? 0;
    }

    public get winBelowStake(): boolean {
        return SlotGame.apiPlugin.gameClientConfiguration.belowStakeWinRestriction && (this.singleWin <= this.playedBetValue);
    }

    public get singleWin(): number {
        return this.data.totalSpinWinnings ?? 0;
    }

    public get playedBetValue(): number {
        return this.data.playedBetValue ?? 0;
    }

    public get betWayWins(): IBetWayWinData[] {
        return this._winData;
    }

    public get allBetWayWinData(): IAllWinData {
        return this._allBetWayWinData;
    }

    public get winRatio(): number {
        return this.singleWin / this.playedBetValue;
    }

    public get evalSize(): number {
        return this.data.evaluatedArea ? ArrayHelper.countWithCondition(this.data.evaluatedArea[0], (s) => s != "") : 4;
    }

    public get WereGoodFS(): boolean {
        return this.data.mode !== SanGameMode.NORMAL && this.totalWinRatio > (this.data.mode === SanGameMode.FREESPIN ? 100 : 400);
    }

    public get totalWinRatio(): number {
        return this.totalWin / this.playedBetValue;
    }

    public get shouldShowTotalWin():boolean{
        return this.data.mode !== SanGameMode.NORMAL || (this.totalWin != this.singleWin);
    }

    public get isBigWin(): boolean {
        return this.winRatio > GameConfig.WIN_RATIOS.bigWin[0].ratio;
    }

    public get BoomWin(): boolean {
        if(this.data.numJumpingWilds === 1){
            return this.winRatio > 250;
        }else if(this.data.numJumpingWilds === 2){
            return this.winRatio > 1250;
        }else
            return this.winRatio > 6250;
    }

    public get winRatioConfig(): IWinRatioConfig {
        return this.getWinRatioConfig(this.winRatio, GameConfig.WIN_RATIOS.normalWin.concat().concat(GameConfig.WIN_RATIOS.bigWin));
    }

    public get evaluateArea(): string[][] {
        return this.data.evaluatedArea ?? [];
    }

    apply(data: any): void {
        super.apply(data);

        this._winData = this.data.evaluatedArea && this.data.betWayWins ? this.addBetLvls(this.createBetWaysWins(this.data.evaluatedArea, this.data.betWayWins), this.playedBetValue, GameConfig.WIN_RATIOS!.normalWin) : [];
        this._winData.sort((a, b) => b.amount - a.amount);

        this._allBetWayWinData = this.parseAllHits(this._winData, this.data.reels.length, this.evalSize);

    }

    protected createWaysNearWins(windowReel: string[][], reelHeight:number[]) {
        const bigMap:any[] = [];

        const filteredReels = windowReel.map((r, reel) => r.map((w, row) => {
            if (row == 0 || reelHeight[reel] < row) return "";
            return w;
        }).filter(v => !!v));

        filteredReels[0].forEach((symTarget,indx) => {
            let lengthCounter = 1;
            let miniTest:boolean[][] = [];
            for (let reelIndx: number = 1; reelIndx < filteredReels.length; reelIndx++) {
                if(lengthCounter != reelIndx)
                    miniTest.push(ArrayHelper.initArrayWithValues(filteredReels[reelIndx].length, () => false));
                else{
                    const reelHits = reelHitBoolPos(filteredReels[reelIndx], [symTarget, BasicSymbolType.WILD]);
                    if(reelHits.find(v => v)){
                        lengthCounter++;
                        miniTest.push(reelHits);
                    }else{
                        miniTest.push(ArrayHelper.initArrayWithValues(filteredReels[reelIndx].length, () => false));
                    }
                } 
            }
            if(lengthCounter >= 3){
                miniTest = [reelHitBoolPos(filteredReels[0], [symTarget, BasicSymbolType.WILD])].concat(miniTest);
            }else{
                ArrayHelper.eachForEach(miniTest,(reel,row,val) => {
                    miniTest[reel][row] = false;
                })
                miniTest = [ArrayHelper.initArrayWithValues(filteredReels[0].length, () => false)].concat(miniTest);
            }
            bigMap.push(miniTest);
        })

        const resMap:boolean[][] = ArrayHelper.initArrayWithValues(filteredReels.length,
             (r) => ArrayHelper.initArrayWithValues(filteredReels[r].length, () => false))
        
        bigMap.forEach(v => {
            ArrayHelper.eachForEach(v,(reel,row,val) => {
                if(val) resMap[reel][row] = val;
            })
        })

        function reelHitBoolPos(reel: string[], symbolType: string[]): boolean[] {
            return reel.map((val: string) => {
                return checker(val, symbolType);
            });
        }

        function checker(symbol: string, target: string[]): boolean {
            return !!target.find(v => v === symbol);
        }
        return resMap;
    }
}